var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"roundboxmenu cart",attrs:{"href":"/cart.php?act=step2","title":"Shopping Cart"}},[_c('i',{staticClass:"fa fa-cart-plus",staticStyle:{"font-size":"1.2em"}}),_vm._v(" Cart ( "+_vm._s(this.countItems)+" )")])}
var staticRenderFns = []

export { render, staticRenderFns }